import * as Font from 'expo-font'
import {
  PlusJakartaSans_400Regular,
  PlusJakartaSans_400Regular_Italic,
  PlusJakartaSans_600SemiBold,
  PlusJakartaSans_700Bold,
  PlusJakartaSans_700Bold_Italic,
  PlusJakartaSans_800ExtraBold,
} from '@expo-google-fonts/plus-jakarta-sans'
import {
  Poppins_700Bold,
  Poppins_400Regular,
  Poppins_600SemiBold,
} from '@expo-google-fonts/poppins'
import { type PropsWithChildren, useEffect } from 'react'
import type { fontFamilies } from '@/src/common/theme'
import { DesignSystem } from '@/src/design-system'
import { sentryCaptureException } from '@/src/common/hooks/useLogError'
import { isProduction } from '@/src/common/environment'
import { StyleSheet } from 'react-native'

/** @see {@link https://mesamember.slack.com/archives/C0884P3TW64/p1749952415476379?thread_ts=1743458887.527979&cid=C0884P3TW64} */
export function FontLoadingGate(props: PropsWithChildren) {
  const [loaded, error] = Font.useFonts({
    'PlusJakartaSans-Regular': PlusJakartaSans_400Regular,
    'PlusJakartaSans-Italic': PlusJakartaSans_400Regular_Italic,
    'PlusJakartaSans-SemiBold': PlusJakartaSans_600SemiBold,
    'PlusJakartaSans-Bold': PlusJakartaSans_700Bold,
    'PlusJakartaSans-BoldItalic': PlusJakartaSans_700Bold_Italic,
    'PlusJakartaSans-ExtraBold': PlusJakartaSans_800ExtraBold,
    'Poppins-Regular': Poppins_400Regular,
    'Poppins-SemiBold': Poppins_600SemiBold,
    'Poppins-Bold': Poppins_700Bold,
    'Inter-Medium': require('@tamagui/font-inter/otf/Inter-Medium.otf'),
    'Inter-Bold': require('@tamagui/font-inter/otf/Inter-Bold.otf'),
  } as const satisfies { [key in keyof typeof fontFamilies]: number })

  useEffect(() => {
    if (!isProduction && error) {
      console.error(error)
      sentryCaptureException(error)
    }
  }, [error])

  return (
    <>
      {props.children}
      {loaded || error ? null : <DesignSystem.Loading.Screen style={StyleSheet.absoluteFill} />}
    </>
  )
}
